/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tId } from './common';

const tLocation = t.type({
  id: t.string,
  name: t.string,
});

export const tSquareIntegration = t.type({
  id: tId,
  location_id: t.union([t.string, t.null]),
  enabled: t.union([t.boolean, t.undefined]),
  authorized: t.union([t.boolean, t.undefined]),
  locations: t.array(tLocation),
});
export type SquareIntegration = t.TypeOf<typeof tSquareIntegration>;

export type SquareAuthorizationUrlPayload = {
  url: string;
};

export type SquareAuthorizationPayload = {
  store_id: number;
};
